/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:40:50                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 16:02:48                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Services
  * DetailsDrawer: display details drawer
*/

/* Imports */
import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { Modal, Switch } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { CalendarIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
/***/

/* Components */
/***/

/* Services */
import { downloadWorkorderReport } from "../../../../../services/export/workorderReport";
/***/

import "./PlanningModal.scss";
import Loading from "../../../../../components/loading/Loading";

/**
* DetailsDrawer: display details drawer
* @param time - time to display
* @param onUpdate - on update callback, return updated time
*/
export default function DowloadWorkorderReportModal({
  open,
  workorder,
  onClose
}: {
  open: boolean,
  workorder: EasyTech.Workorder
  onClose: () => void
}) {
  const [downLoad, setDownLoad] = useState<boolean>(false);   
  const [withImages, setWithImages] = useState<boolean>(true); 
  
  const downloadWoReport = async () => {
    setDownLoad(true);
    try {
      await downloadWorkorderReport({
        workorderId: workorder.id,
        workorderRef: workorder.ref,
        includeImages: withImages,
      });
    } catch (err) {
      console.error("Erreur lors du téléchargement du rapport:", err);
      toast.error(t("workorder:report:downloadError"));
    } finally {
      setDownLoad(false);
      onClose();
    }
  };
  
  return(
    
    <Modal
      open={open}
      onClose={onClose}
      className="te-modal"
      aria-labelledby="te-modal"
      aria-describedby="te-modal">
      <Card className="te-modal-content  rounded-lg">
        <button className="close-button" onClick={() => onClose()} disabled={downLoad}>
          <XMarkIcon className="w-4"/>
        </button>
        <CardBody>
          <div  className="flex items-center gap-3 mb-5">
            <div className="rounded-full border p-2 bg-light-green-200">
              <CalendarIcon className="w-7 text-green-700" /> 
            </div>
            <Typography variant="h5">
              {t("admin:interventions:download:title", { ref: workorder.ref })}
            </Typography>
          </div>
         
          <div className="field flex flex-row items-center gap-2">
            <div className="flex flex-col">
              <label>{t("Add images")}</label>
  
              <span className="text-sm text-gray-500 mt-1">
                {t("Download intervention report will also contain the intervention images.")}
              </span>
            </div>
  
            <Switch checked={withImages}
                    onChange={(event: any, e: boolean) => setWithImages(e)}/>
          </div>
        </CardBody>
        <CardFooter className="pt-0 flex gap-2 justify-end">
          

          {downLoad ?
            <Loading />
            :
            <>
              <Button variant="outlined"
                      onClick={onClose}>
                {t("common:cancel")}
              </Button>
              <Button color="blue"
                      onClick={() => downloadWoReport()}>
                {t("admin:buttons:download")}
              </Button>
            </>
          }
        </CardFooter>
      </Card>
    </Modal>
  );
}
/***/
